import { LocalizedText } from "@/i18n/LocalizedText";
import { Spinner } from "@/components/ui/spinner";
import { capturePosthogEvent } from "@/lib/posthog";
import { trackMetaPixelLeadOnce } from "@/lib/metaPixel";
import { billingAPI } from "@/services/api";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/components/AuthContext";
import { consumeTryReturn } from "@/lib/tryLink";

const BillingSuccessPage = () => {
  const navigate = useNavigate();
  const { refreshUser, user } = useAuth();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    let active = true;
    const confirm = async () => {
      try {
        const sessionId = String(searchParams.get("session_id") || "").trim();
        const result = await billingAPI.confirm(sessionId || undefined);
        if (!active) return;
        if (result?.can_enter_app) {
          capturePosthogEvent("stripe_checkout_completed", {
            plan: result.plan,
            interval: result.interval,
            subscription_status: result.subscription_status,
            trial_started: result.trial_started,
          });
          trackMetaPixelLeadOnce(user?.id);
          await refreshUser().catch(() => undefined);
          navigate(
            consumeTryReturn() ? "/try" : "/dashboard/overview",
            { replace: true },
          );
          return;
        }
      } catch {
        // handled by fallback redirect below
      }
      if (!active) return;
      navigate("/onboarding/plan", { replace: true });
    };
    void confirm();
    return () => {
      active = false;
    };
  }, [navigate, refreshUser, searchParams, user?.id]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-[#FAFAFA] px-4">
      <Spinner variant="circle-filled" size={48} />
      <h1 className="text-2xl font-semibold text-[#171717]">
        <LocalizedText id="legacy.confirming.your.subscription.1cxxzad" />
      </h1>
      <p className="max-w-lg text-center text-[#737373]">
        <LocalizedText id="legacy.we.are.verifying.your.stripe.checkout.you.will.t01kqq" />
      </p>
    </div>
  );
};

export default BillingSuccessPage;
